import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import WaitlistForm from '../components/WaitlistForm';
import {
  setWaitListBooking,
  setWaitListBookingReason,
  setWaitListBookingComment
} from 'routes/DateSelection/reducer';
import {
  isWaitListBookingSelector,
  waitListBookingReasonSelector,
  waitListBookingCommentSelector
} from 'routes/DateSelection/selectors';

const mapStateToProps = createStructuredSelector({
  isWaitListBooking: isWaitListBookingSelector,
  waitListBookingReason: waitListBookingReasonSelector,
  waitListBookingComment: waitListBookingCommentSelector
});

function mapDispatchToProps(dispatch) {
  return {
    setIsWaitListBooking: isWaitListBooking =>
      dispatch(setWaitListBooking(isWaitListBooking)),
    setWaitListBookingReason: reason =>
      dispatch(setWaitListBookingReason(reason)),
    setWaitListBookingComment: comment =>
      dispatch(setWaitListBookingComment(comment))
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WaitlistForm);
